import { axiosInstances } from '../../utilities/axios/Instances/axios.instances';
import { authStorage } from './authStorage';

const isLoggedIn = () => {
  const token = authStorage.getAuthToken();
  return token !== undefined && token !== null;
};
const getToken = () => {
  return authStorage.getAuthToken();
};
const getOfficeAuthUrl = () => {
  return axiosInstances.withBaseUrl().get('/auth/login');
};
const login = (username, password) => {
  //call within try catch block
  return processLogin({ username, password });
};
const loginViaCode = code => {
  //call within try catch block
  return processLogin({ code });
};
const processLogin = async reqBody => {
  const { data: res } = await axiosInstances.withBaseUrl().post('/auth/login', reqBody);
  if (res && res.auth_token) {
    authStorage.setAuthToken(res.auth_token);
  } else {
    console.log('res error', res);
    throw new Error('unknown_error');
  }
};
const logout = () => {
  authStorage.clearAuthToken();
};
export const authenticationService = {
  isLoggedIn,
  getToken,
  getOfficeAuthUrl,
  login,
  loginViaCode,
  logout
};
